import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { images } from 'utils/icons';

import styles from './index.module.scss';
import { icons } from 'Icons';

const Activity = ({ value, displayType = 'default' }) => {
  const renderIcon = () => {
    const Component = icons[value]?.default;
    return <Component />;
  };

  return displayType === 'icon' && icons[value]?.default ? (
    renderIcon()
  ) : displayType === 'icon' ? (
    <Image className={styles.img} src={value[displayType]} />
  ) : (
    <Image className={styles.img} src={images[value]?.default} />
  );
};
Activity.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  displayType: PropTypes.oneOf(['default', 'icon']),
};

export default Activity;
